import { createFileRoute } from '@tanstack/react-router';
import { SnapshotAdminDetail } from '@features/snapshot-admin/SnapshotAdminDetail';

export const Route = createFileRoute('/w/contracts/$snapshotId')({
  staticData: { breadcrumb: 'Contract Detail', breadcrumbKey: 'K_BREADCRUMB_CONTRACT_DETAIL' },
  component: ContractDetailPage,
});

function ContractDetailPage() {
  const { snapshotId } = Route.useParams();
  return <SnapshotAdminDetail snapshotId={snapshotId} />;
}
